import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface GatewayInfo {
  id: string
  name: string
  serial_number: string
  device_type: string
  device_type_id?: string
  gateway_type_id?: string
  comm_type: string
  rem_bat_percent: string
  comm_mod_serial: string
  asset_state: string
  latitude: string
  longitude: string
  install_date: string
  removal_date: string
  firmware_version: string
  ip_address: string
  port: string
  description: string
  application_type: string
  asset_model_id: string
  asset_category_id: string
  site_id: string
  asset_model_name: string
  asset_category_name: string
  communication_status: string
  hierarchy: string
  slave_id: number
  asset_type_id: string
  parent_asset_id: string
  communication_protocol_id: string
  timezone: string
}

export interface GatewayInfoState {
  isLoading: boolean
  loadingError: string | null
  gatewayInfo: GatewayInfo | null
  httpStatus: number | null
}

export const initialState: GatewayInfoState = {
  isLoading: true,
  loadingError: null,
  gatewayInfo: null,
  httpStatus: null
}

const gatewayInfoSliceGateway = createSlice({
  name: 'gatewayManagementGatewayInfo',
  initialState,
  reducers: {
    gatewayInfoLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        gatewayInfo: null,
        httpStatus: 0
      }
    },
    gatewayInfoUpdateAction: (state, action: PayloadAction<{ data: GatewayInfo, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        gatewayInfo: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    gatewayInfoErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        gatewayInfo: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  gatewayInfoLoadingAction,
  gatewayInfoUpdateAction,
  gatewayInfoErrorAction
} = gatewayInfoSliceGateway.actions

export default gatewayInfoSliceGateway.reducer
